var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.mostrarBtn)?_c('span',[_c('b-button',{attrs:{"variant":"warning"},on:{"click":function($event){$event.stopPropagation();return _vm.confirmarRetornarPagamento()}}},[_c('span',[_c('i',{staticClass:"fa fa-undo"}),_vm._v(" Retornar Pagamento ")])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }